import SmartLayout from "theme/layouts/SmartLayout";

export default SmartLayout;
